/** @jsx jsx */
import { jsx } from '@emotion/core';

import { IQuizFormInput } from '../../quiz.types';
import { ChoiceInput } from './ChoiceInput/ChoiceInput';
import { ScaleInput } from './ScaleInput/ScaleInput';
import { TextInput } from './TextInput/TextInput';
import { UploadInput } from './UploadInput/UploadInput';

// ---------------------------------------------------------------------------
// Dispatcher — picks the right input component for a FormInput
// ---------------------------------------------------------------------------
export function QuestionInput({
  input,
}: {
  input: IQuizFormInput;
}): JSX.Element {
  // Scale detection: choice type with minAnswer + maxAnswer defining a numeric range (e.g. 1–10),
  // where formInputChoices are purely label hints (≤ 2) and the range span > 1.
  // A regular multi-choice (checkboxes) has maxAnswer = number of selectable options,
  // which is typically much smaller than the total number of choices available.
  // Key discriminator: for a scale, maxAnswer > formInputChoices.length (the range is wider
  // than the labels array), whereas for checkboxes maxAnswer <= formInputChoices.length.
  const isScale =
    input.type === 'choice' &&
    input.minAnswer !== null &&
    input.maxAnswer !== null &&
    input.maxAnswer > 1 &&
    input.formInputChoices.length <= 2 &&
    input.maxAnswer > input.formInputChoices.length;

  if (isScale) return <ScaleInput input={input} />;
  if (input.type === 'text') return <TextInput input={input} />;
  if (input.type === 'upload') return <UploadInput input={input} />;
  return <ChoiceInput input={input} />;
}
